import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react'

export const McdInvFileList = ({ mcdInvId }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcdInvId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcdInvId', mcdInvId));
  }, [mcdInvId]);

  return (
    <EntityList entity="MCD_INV_FILE" augRowsReq={augRowsReq}/>
  )
}